import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={9} lg={7} className="m-auto text-center">
            <h3 className="h3_head">
              Our Next-Gen Tool Box to <span>Build Web Applications</span>
            </h3>
            <p>
              Our web application development solutions utilize a high-level
              tech stack with a set of reliable and efficient technologies.
              These innovative tools are then wisely incorporated to develop
              standards-compliant, scalable, and futuristic web solutions for a
              wide range of clients and domains. Our expertise spans:
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/frontend/AngularJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AngularJs</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/frontend/CSS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>CSS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/frontend/EmberJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>EmberJs</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/frontend/JS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>JavaScript</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/frontend/Meteor.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Meteor</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/frontend/NextJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>NextJs</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/frontend/NueJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>VueJs</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/frontend/Reactnative.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>ReactJS</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/backend/Go_lan.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Go lan</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/backend/Java.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Java</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/backend/MS.Net.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>MS.Net</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/backend/Php.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Php</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/backend/python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/backend/Node-js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Node js</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/database/CakePHP.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>CakePHP</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/database/Codelgniter.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Codelgniter</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/database/maria_db.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Maria DB</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/database/RxWeb.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>RxWeb</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/database/SQL_server.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>SQL Server</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Web Platforms">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/platfrom-web/Dynamic_365.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Dynamic 365</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/platfrom-web/SalesForce.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>SalesForce</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/web-app-dev/platfrom-web/SharePOint.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>SharePoint</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
